import type { CSSProperties } from 'react';
import React from 'react';
import styles from './board-tile.module.scss';
import { BoardTileFace } from './board-tile-face';
import type { TileData } from './board-types';

interface BoardTileProps {
  tile: TileData;
  cellSize: number;
  gap: number;
  padding: number;
  draggable?: boolean;
  isDragging?: boolean;
  /** Part of a cluster — letter only, with the cluster's shape drawing the chrome. */
  bare?: boolean;
  style?: CSSProperties;
  onKeyDown?: (e: React.KeyboardEvent, tile: TileData) => void;
  onClick?: (e: React.MouseEvent, tile: TileData) => void;
}

/** A tile positioned at its board coordinates and wired for interaction. */
export const BoardTile = React.forwardRef<HTMLDivElement, BoardTileProps>(function BoardTile(
  { tile, cellSize, gap, padding, draggable = false, isDragging = false, bare = false, style, onKeyDown, onClick },
  ref,
) {
  const ariaLabel = `Tile ${tile.letter.split('').join('-')}, ${tile.points} point${tile.points === 1 ? '' : 's'}, at row ${tile.row + 1} column ${tile.col + 1}`;

  return (
    <BoardTileFace
      ref={ref}
      tile={tile}
      cellSize={cellSize}
      gap={gap}
      padding={padding}
      bare={bare}
      role="button"
      tabIndex={draggable ? 0 : -1}
      aria-grabbed={isDragging || undefined}
      aria-label={ariaLabel}
      className={draggable ? styles.draggable : undefined}
      style={style}
      onKeyDown={onKeyDown ? (e) => onKeyDown(e, tile) : undefined}
      onClick={onClick ? (e) => onClick(e, tile) : undefined}
    />
  );
});
